import { component } from 'picoapp'
import '@/lib/jquery-global.js';

export default component((node, ctx) => {
  
    const faq_header = node.querySelector('.accordion-header')
    const faq_content = node.querySelector('.accordion-content')

    
    jQuery(faq_header).click(function() {
        jQuery(this).toggleClass('accordion--open');
        jQuery(faq_content).slideToggle();
    });
  
})
